import React, { Component } from 'react';
import './../../assets/css/App.css';
import Highcharts from 'highcharts';
import Select from './../select/';
import Utils from './../../component/utils/utils';

class AreaSplineChartWithHeader extends Component {
    state = {
        options: {
            chart: {
                type: 'areaspline'
            },
            title: {
                text: this.props.chartTitle
            },
            xAxis: {
                categories: this.props.histogramChartCategoriesList
            },
            yAxis: {
                title: {
                    text: this.props.yAxisTitle
                }
            },
            tooltip: {
                headerFormat: '<span style="font-size:11px"><b>Date: {point.x}</b></span><br>',
                pointFormat: this.props.dolarSignFormat != undefined ? '<span style="color:{point.color}">{series.name}: </span><b>${point.y}</b><br>' :
                    '<span style="color:{point.color}">{series.name}: </span><b>{point.y}</b><br>',
                shared: true
            },
            plotOptions: {
                series: {
                    borderWidth: 0,
                    dataLabels: {
                        enabled: true,
                        format: this.props.dolarSignFormat != undefined ? '${point.y:.2f}' : '{point.y}',
                    }
                }
            },
            series: this.props.histogramChartSeriesDataList
        },

    }

    componentDidMount() {
          this.chart = new Highcharts[this.props.type || "Chart"](
            this.refs.chart,
            this.state.options
        );
    }

    componentWillUnmount() {
        this.chart.destroy();
    }

    updateChartConfig = () => {
        if (this.chart !== undefined) {
            this.chart.update({
                tooltip: {
                    headerFormat: '<span style="font-size:11px"><b>Date: {point.x}</b></span><br>',
                    pointFormat: this.props.dolarSignFormat != undefined ? '<span style="color:{point.color}">{series.name}: </span><b>${point.y}</b><br>' :
                        '<span style="color:{point.color}">{series.name}: </span><b>{point.y}</b><br>',
                    shared: true
                },
            })

            this.chart.setTitle({text: this.props.chartTitle});
            this.chart.xAxis[0].categories = this.props.histogramChartCategoriesList;
            var self = this;
            this.props.histogramChartSeriesDataList.forEach(function(item, index) {
                self.chart.series[index].setData(self.props.histogramChartSeriesDataList[index].data, true);
            });
        }
    }

    selectElementChange = (event) => {
        this.props.selectElementChange(event);
    };

    // refresh button actions
    searchButtonAction = () => {
        this.props.searchButtonAction();
    };

    render() {
        // this code re renders the chart
        this.updateChartConfig();
        return (
            <div className="">
                <div className = "portlet box blue-hoki">
                    <div className = "portlet-title p-l-r-10">
                        <div className="caption">
                            <i className={this.props.headerIconClass}></i>
                            {this.props.chartTitle}</div>
                        <div className="actions">
                            <Select className={"packages-status-dropdown"}
                                    controlFunc={this.selectElementChange}
                                    options = {this.props.selectDropdownValues}>
                            </Select>
                            <input type="button" value="Refresh" className="button-right btn-info"
                                   onClick={this.searchButtonAction} />
                        </div>
                    </div>
                </div>

                <div ref="chart"/>
            </div>
        )
    }
}
export default AreaSplineChartWithHeader;